module.exports = __webpack_public_path__ + "static/media/star_filled.12b8d81d.svg";